module.exports = __webpack_public_path__ + "static/media/internetexplorer.a523b8a5.svg";